export default "__VITE_ASSET__f3ogpEEP__"